var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TheMask, mask } from 'vue-the-mask';
import * as Yup from 'yup';
var WhatsappModal = /** @class */ (function (_super) {
    __extends(WhatsappModal, _super);
    function WhatsappModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.values = {
            name: '',
            phone: '',
            email: '',
        };
        _this.errors = {
            name: '',
            phone: '',
            email: '',
        };
        return _this;
    }
    Object.defineProperty(WhatsappModal.prototype, "visible", {
        get: function () {
            return this.$store.state.whatsappModal.visible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WhatsappModal.prototype, "destinationPhone", {
        get: function () {
            return (this.$store.state.whatsappModal.phone || '').replace(/\D/g, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WhatsappModal.prototype, "baseMessage", {
        get: function () {
            return this.$store.state.whatsappModal.message || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WhatsappModal.prototype, "propertyCod", {
        get: function () {
            return this.$store.state.whatsappModal.propertyCod || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WhatsappModal.prototype, "propertyMessage", {
        get: function () {
            return this.$store.state.whatsappModal.propertyMessage || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WhatsappModal.prototype, "propertyFinality", {
        get: function () {
            return this.$store.state.whatsappModal.propertyFinality || 'sale';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WhatsappModal.prototype, "validationFormSchema", {
        get: function () {
            var shape = {
                phone: Yup.string().test('length', 'Digite o telefone corretamente', function (val) {
                    var newVal = (val === null || val === void 0 ? void 0 : val.replace(/\D/g, '')) || '';
                    return newVal.length === 10 || newVal.length === 11;
                }),
                name: Yup.string().required('Esse campo é obrigatório'),
            };
            if (this.requiredEmail) {
                shape.email = Yup.string()
                    .required('Esse campo é obrigatório')
                    .email('Digite um email válido');
            }
            return Yup.object().shape(shape);
        },
        enumerable: false,
        configurable: true
    });
    WhatsappModal.prototype.close = function () {
        this.$store.commit('closeWhatsappModal');
        this.resetForm();
    };
    WhatsappModal.prototype.resetForm = function () {
        this.values = { name: '', phone: '', email: '' };
        this.errors = { name: '', phone: '', email: '' };
    };
    WhatsappModal.prototype.validate = function (field) {
        var _this = this;
        this.validationFormSchema
            .validateAt(field, this.values)
            .then(function () {
            _this.errors[field] = '';
        })
            .catch(function (err) {
            _this.errors[field] = err.message;
        });
    };
    WhatsappModal.prototype.buildPropertyIntro = function () {
        if (this.propertyMessage) {
            return this.propertyMessage;
        }
        if (this.propertyCod) {
            return "Gostaria de receber mais informa\u00E7\u00F5es sobre o im\u00F3vel de refer\u00EAncia " + this.propertyCod;
        }
        return '';
    };
    WhatsappModal.prototype.buildWhatsappMessage = function () {
        var intro = this.buildPropertyIntro();
        if (intro) {
            return intro;
        }
        return this.baseMessage.trim();
    };
    WhatsappModal.prototype.buildSharedUrl = function () {
        console.log(this.values);
        var params = new URLSearchParams({
            phone: this.destinationPhone,
            phone_user: this.values.phone.replace(/\D/g, ''),
            name: this.values.name,
            message: this.buildWhatsappMessage(),
        });
        if (this.values.email) {
            params.set('email', this.values.email);
        }
        if (this.propertyCod) {
            params.set('property-id', this.propertyCod);
        }
        if (this.propertyFinality) {
            params.set('finality', this.propertyFinality);
        }
        return "/whatsapp-shared?" + params.toString();
    };
    WhatsappModal.prototype.submit = function (event) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        event.preventDefault();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.validationFormSchema.validate(this.values, { abortEarly: false })];
                    case 2:
                        _c.sent();
                        this.errors = {};
                        if (window.onClickTag) {
                            try {
                                (_b = (_a = window).onClickTag) === null || _b === void 0 ? void 0 : _b.call(_a);
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                        window.location.href = this.buildSharedUrl();
                        this.close();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        if (err_1.inner) {
                            err_1.inner.forEach(function (error) {
                                _this.errors[error.path] = error.message;
                            });
                        }
                        this.$forceUpdate();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WhatsappModal.prototype.onOverlayClick = function (event) {
        if (event.target.classList.contains('whatsapp-modal-overlay')) {
            this.close();
        }
    };
    WhatsappModal.prototype.onKeydown = function (event) {
        if (event.key === 'Escape' && this.visible) {
            this.close();
        }
    };
    WhatsappModal.prototype.mounted = function () {
        document.addEventListener('keydown', this.onKeydown);
    };
    WhatsappModal.prototype.beforeDestroy = function () {
        document.removeEventListener('keydown', this.onKeydown);
    };
    __decorate([
        Prop({ default: false })
    ], WhatsappModal.prototype, "requiredEmail", void 0);
    WhatsappModal = __decorate([
        Component({
            components: {
                TheMask: TheMask,
            },
            directives: { mask: mask },
        })
    ], WhatsappModal);
    return WhatsappModal;
}(Vue));
export default WhatsappModal;
